import { SupplementaryEquipmentComponent } from './component/supplementary-equipment/supplementary-equipment.component';
import { TransportOptionsComponent } from './component/transport-options/transport-options.component';
import { RouteComponent } from './component/route/route.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegistrationComponent } from './component/registration.component';
import { MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MasterDataComponent } from './component/master-data/master-data.component';
import { TransportOptionsEditorModule } from 'src/tmc-yard/components/transport-options-editor/transport-options-editor.module';
import { CommonTranslationModule } from '@sdbn/common';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { TransportOptionsPanelModule } from '../transport-options-panel/transport-options-panel.module';
import { TransportDetailsModule } from 'src/tmc-yard/common/components/transport-details/transport-details.module';


@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    TransportDetailsModule,
    TransportOptionsEditorModule,
    TransportOptionsPanelModule,
    CommonTranslationModule,
    ServiceResponseModule,
    ApplicationClientCommonModule
  ],
  declarations: [
    RegistrationComponent,
    MasterDataComponent,
    RouteComponent,
    TransportOptionsComponent,
    SupplementaryEquipmentComponent,
    MasterDataComponent
  ],
  exports: [
    RegistrationComponent,
    MasterDataComponent,
    RouteComponent,
    TransportOptionsComponent,
    SupplementaryEquipmentComponent,
    MasterDataComponent]
})
export class TransportRegistrationModule { }
